import { render, staticRenderFns } from "./MessageResend.vue?vue&type=template&id=22632784&scoped=true"
import script from "./MessageResend.vue?vue&type=script&lang=js"
export * from "./MessageResend.vue?vue&type=script&lang=js"
import style0 from "./MessageResend.vue?vue&type=style&index=0&id=22632784&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22632784",
  null
  
)

export default component.exports